import { useState } from 'react';

export function createMaximizeState() {
    const [state, setMaximizedState] = useState<boolean>(false);

    const isMaximized = (): boolean => state;

    const maximizeChat = (): void => setMaximizedState(true);

    const minimizeChat = (): void => setMaximizedState(false);

    return {
        state,
        isMaximized,
        maximizeChat,
        minimizeChat
    };
}
